<template>
  <section class="bg-[#fef9f6] py-20">
    <div class="max-w-6xl mx-auto px-6">
      
      <!-- PAGE HEADER -->
      <div class="text-center mb-14">
        <p class="text-sm font-semibold tracking-widest text-teal-600 mb-3">
          FIND OUR CLINIC
        </p>
        <!-- <h1
          class="text-3xl sm:text-4xl md:text-5xl
                 font-extrabold text-[#924f19] mb-6"
        >
          Magnum Dental Clinic, Guwahati
        </h1> -->

<p class="max-w-3xl mx-auto text-gray-600 text-lg leading-relaxed">
  <span class="font-semibold text-xl text-[#924f19]">
    Magnum Dental Clinic
  </span>,
  a trusted dental clinic in Guwahati, is conveniently located at First Floor,
  Global Tower, Pathar Quarry, VIP Road, Guwahati, Assam. Our clinic is easy to
  find and easily accessible for patients seeking quality dental care in and
  around Guwahati.
</p>

      </div>

      <!-- LOCATION INFO CARD -->
      <div class="max-w-4xl mx-auto mb-16">
        <div
          class="bg-white rounded-3xl shadow-sm p-8 md:p-10
                 grid gap-6 text-center"
        >
          <h2 class="text-2xl font-bold text-[#924f19]">
            Our Location
          </h2>

          <p class="text-lg font-semibold text-gray-800">
            Magnum Dental Clinic – Guwahati
          </p>

          <div class="space-y-2 text-gray-600 text-base">
            <p>
              📍 First Floor, Global Towers, VIP Road, Pathar Quarry,
              Guwahati-781171, Assam, India
            </p>
            <p>📞 +91 8638940021</p>
            <p>🕒 Monday – Sunday: 9:30 AM – 7:30 PM</p>
          </div>

          <p class="text-gray-500 text-sm mt-2">
            We are centrally located in Guwahati, ensuring easy access from
            major residential areas, commercial hubs, and public transport
            routes.
          </p>
        </div>
      </div>
    </div>

    <!-- FULL WIDTH MAP -->
    <div class="w-full">
      <iframe
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3581.0234952437877!2d91.82038757549843!3d26.163364277101728!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x375a59d4a0943b0b%3A0x1982892a3cd706ff!2sMagnum%20Dental%20Clinic%20-%20Guwahati!5e0!3m2!1sen!2sin!4v1768125497144!5m2!1sen!2sin"
        class="w-full h-[420px] md:h-[520px]"
        style="border:0;"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  </section>
</template>

<script>
import { useHead } from "@vueuse/head";

export default {
  name: 'ContactView',
  setup() {
    useHead({
      title: "Dental Clinic on VIP Road Guwahati | Magnum Dental Clinic Location",
      meta: [
        {
          name: "description",
          content:
            "Find Magnum Dental Clinic on VIP Road, Guwahati — First Floor, Global Towers, Pathar Quarry, Guwahati 781171. Open Mon–Sun 9:30 AM–7:30 PM. Call +91 8638940021.",
        },
        {
          name: "robots",
          content: "index, follow",
        },
        {
          property: "og:title",
          content: "Dental Clinic on VIP Road Guwahati | Magnum Dental Clinic Location",
        },
        {
          property: "og:url",
          content: "https://www.magnumdentalguwahati.in/dental-clinic-in-vip-road",
        },
      ],
      link: [
        { rel: "canonical", href: "https://www.magnumdentalguwahati.in/dental-clinic-in-vip-road" },
      ],
    });
  },
  data() {
    return {
      form: {
        name: '',
        email: '',
        subject: '',
        message: ''
      }
    };
  },
  methods: {
    submitForm() {
      alert('Thank you for contacting us!');
      // Reset form if needed:
      this.form = {
        name: '',
        email: '',
        subject: '',
        message: ''
      };
    }
  }
};
</script>

<style scoped>
.input {
  @apply border border-gray-300 rounded px-4 py-2 focus:outline-none focus:ring-2 focus:ring-teal-400;
}
</style>
